
import { mapActions, mapGetters, mapMutations, mapState} from 'vuex'
import dayjs from 'dayjs'
import SearchOnlyPeriod2 from '~/components/Common/UI/Search/SearchOnlyPeriod2'

export default {
    components: {
        SearchOnlyPeriod2,
    },
    data() {
        return {
            curPage: 1,         // 현재페이지
            countByPage: 25,    // 한페이지당 갯수
            componentKey: 0,
            original: {},
            short: [],
            detailList: [],
            detailIdx: null,
            loadingStatus : true,
            startDate : null,
            endDate : null,
            ifChecked: '', // 정렬기준 선택값 
        }
    },
    computed: {
        ...mapGetters('search', ['getSearch']),
        ...mapState('research', ['recentIssueList', 'recentIssueDetail']),

        // 전체 글의 수
        setTotalCount() {
            let count = 0
            if (this.recentIssueList !== undefined && this.recentIssueList.items !== undefined && this.recentIssueList.items.length > 0) {
                count = this.recentIssueList.totalCount
            }
            return count
        },
    },
    watch: {
        getSearch() {
            /* 
                220530 meej 날짜 검색시 page reset
             */
            this.curPage= 1       
            this.countByPage= 25    
            this.getList()
        },
        original() {
            this.forceRerender()
        },
        // 최근이슈 발생 리스트
        recentIssueList(){ 
            this.original = this.recentIssueList
        },
        // 최근 이슈 발생의 세부내용
        recentIssueDetail(){ 
            this.detailList = this.recentIssueDetail
        },
    },
    created() {
        // 초기값 : 당일
        this.startDate = dayjs(new Date()).format('YYYY-MM-DD')
        this.endDate = dayjs(new Date()).format('YYYY-MM-DD')
        this.ifChecked = ''
    },

    methods: {
        ...mapActions('research', ['GET_RECENTISSUE', 'GET_RECENTISSUE_DETAIL']),

        // 페이지 번호 클릭시 
        onClickPage(page) {
            this.curPage = page
            this.getList()
        },
        forceRerender() {
            this.componentKey += 1
        },
        getList() {
            this.loadingStatus = true
            this.GET_RECENTISSUE({
                pageNo: this.curPage,
                countByPage: this.countByPage,
                ...this.getSearch,
                order: '',
            }).then(()=>{
                this.loadingStatus = false;
            }) 
        },
        getDetail(code) {
            this.loadingStatus = true
            this.GET_RECENTISSUE_DETAIL({
                stockCode: code,
                ...this.getSearch,
            }).then(()=>{
                this.loadingStatus = false;
            }) 
        },
        onClickitem(id, code) {
            // 클릭한 목록 외의 나머지 목록상세내용은 안보이게 처리
            this.detailList = []
            if (this.detailIdx !== null && this.detailIdx !== id) {
                const el = document.getElementById(this.detailIdx)
                if (el.style.display === 'table-row') {
                    el.style.display = 'none'
                }
            }
            const el = document.getElementById(id)
            if (el.style.display === 'table-row') {
                // 다시 누를 경우 안보이게 처리
                el.style.display = 'none'
            } else {
                // 목록 클릭시 세부내용 조회
                this.getDetail(code)
                el.style.display = 'table-row'
                this.detailIdx = id
            }
        },
        // 22.06.22 suye 최근 이슈발생 종목 열제목별 정렬 추가 
        changeOrder(by){
            this.ifChecked = by 
            this.loadingStatus = true
                this.GET_RECENTISSUE({
                    pageNo: this.curPage,
                    countByPage: this.countByPage,
                    ...this.getSearch,
                    order: by,
                }).then(()=>{
                    this.loadingStatus = false; 
                }) 
        },
    },
}
